import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getBusinessConversations } from "../api/chatService";

// Mirrors AppContext.js's UNREAD_POLL_INTERVAL_MS on the business owner mobile app.
const POLL_INTERVAL_MS = 20000;

const BusinessMessagesContext = createContext(null);

export function BusinessMessagesProvider({ children }) {
  const [conversations, setConversations] = useState([]);

  const refresh = useCallback(() => {
    return getBusinessConversations()
      .then(setConversations)
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [refresh]);

  const unreadCount = conversations.reduce((sum, c) => sum + c.unreadCount, 0);

  const value = { conversations, unreadCount, refresh };

  return <BusinessMessagesContext.Provider value={value}>{children}</BusinessMessagesContext.Provider>;
}

export function useBusinessMessages() {
  const context = useContext(BusinessMessagesContext);
  if (!context) {
    throw new Error("useBusinessMessages must be used within a BusinessMessagesProvider");
  }
  return context;
}
